import { v } from 'h3-valibot';

export const parseURL = v.pipe(
  v.string(),
  v.rawTransform(({ dataset, addIssue, NEVER }) => {
    try {
      return new URL(dataset.value);
    } catch (e) {
      addIssue({
        message: `Invalid URL ${e}`
      });
      return NEVER;
    }
  })
);
